// extracted by mini-css-extract-plugin
export default {"tableContainer":"ActivitiesTable_tableContainer__wneVa"};